import { render, staticRenderFns } from "./ResearchListYjj.vue?vue&type=template&id=120abd60&scoped=true&"
import script from "./ResearchListYjj.vue?vue&type=script&lang=js&"
export * from "./ResearchListYjj.vue?vue&type=script&lang=js&"
import style0 from "./ResearchListYjj.vue?vue&type=style&index=0&id=120abd60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120abd60",
  null
  
)

export default component.exports